import { useEffect, useId } from 'react';
import { useCarrier } from '../contexts/CarrierContext';

export default function useUnsavedGuard(dirty, label) {
  const id = useId();
  const { registerUnsaved, clearUnsaved } = useCarrier();
  useEffect(() => {
    if (!dirty) return;
    registerUnsaved(id, label);
    const beforeUnload = (event) => { event.preventDefault(); event.returnValue = ''; };
    window.addEventListener('beforeunload', beforeUnload);
    return () => {
      clearUnsaved(id);
      window.removeEventListener('beforeunload', beforeUnload);
    };
  }, [dirty, label, id, registerUnsaved, clearUnsaved]);
}

export { useUnsavedGuard };
